export enum AvailableSidePanels {
  HeatCurve = 'heat-curve',
  HeatingZoneHeatCurve = 'heating-zone-heat-curve',
  SpaceClimateCooling = 'space-climate-cooling',
  OperatingModeManager = 'operating-mode-manager',
  TemperatureScheduleManager = 'temperature-schedule-manager',
  SrcTemperatureScheduleManager = 'src-temperature-schedule-manager',
  SrcOtherRoomTemperatureScheduleManager = 'src-other-room-temperature-schedule-manager',
  SrcRoomTypeManager = 'src-room-type-manager',
  FhtManager = 'fht-manager',
  EventLog = 'event-log',
  EnergyFlow = 'energy-flow',
  Trending = 'trending',
}

export enum FeaturesDetailsOverlayTypeEnum {
  // feature tile details overlays
  System = 'system',
  Gateway = 'gateway',
  FuelCell = 'fuel-cell',
  HeatingCircuit = 'heatingCircuit',
  CallForHeatHeatingZone = 'CallForHeatHeatingZone',
  CircuitHeatingZone = 'CircuitHeatingZone',
  Dhw = 'dhw',
  Ventilation = 'ventilation',
  RefrigerantCircuit = 'refrigerantCircuit',
  HemsSettings = 'hemsSettings',
  ElectricHeater = 'electric-heater',
  Solar = 'solar',
  Battery = 'battery',
  Photovoltaics = 'photovoltaics',
  GasConsumption = 'gasConsumption',
  SummaryGasConsumption = 'summaryGasConsumption',
  SummaryElectricityConsumption = 'summaryElectricityConsumption',
  HeatProduction = 'heatProduction',
  PowerProduction = 'powerProduction',
  PvImmersionHeaterDetails = 'pvImmersionHeaterDetails',
  SolarPowerProduction = 'solarPowerProduction',
  ElectricityConsumption = 'electricityConsumption',
  FuelConsumption = 'fuelConsumption',
  Autarky = 'autarky',
  WallboxChargingSettings = 'wallboxChargingSettings',
  WallboxSystem = 'wallboxSystem',
  ViCarePlans = 'vicarePlans',
  ViCareThermostat = 'vicareThermostat',
  InternalHydraulic = 'internalHydraulic',
  BufferTank = 'bufferTank',
  HybridProControl = 'hybridProControl',
  // menu bar overlays
  MaintenanceChecklist = 'MaintenanceChecklist',
  MaintenanceInformation = 'MaintenanceInformation',
  ServiceInstruction = 'ServiceInstruction',
  EventLog = 'EventLog',
  ControlUnits = 'controlUnits',
  Trending = 'trending',
  CascadeLagDevice = 'cascadeLagDevice',
  Ecowater = 'ecowater',
  RemoteController = 'remoteController',
  SolarLog = 'solarLog',
  ServiceLayer = 'serviceLayer',
  PowerLimitationHistoryLog = 'powerLimitationHistoryLog',
  None = 'none',
}

export enum DiagnosticsOverlayTypeEnum {
  DiagnosisBackupAndRestore = 'Backups',
  ExtendedParameter = 'ExtendedParameter',
  GuidedTroubleshooting = 'GuidedTroubleshooting',
  HydraulicSchematic = 'HydraulicSchematic',
  DiagnosisSnapshots = 'Snapshots',
  None = 'none',
}

export enum RemoteServiceOverlayTypeEnum {
  Anomalies = 'Anomalies',
  Diagnosis = 'Diagnosis',
  Features = 'Features',
  Report = 'Report',
  None = 'none',
}

export enum SingleRoomControlOverlayTypeEnum {
  SingleRoomControlDetails = 'singleRoomControlDetails',
  SingleRoomControlCommissioning = 'singleRoomControlCommissioning',
  SingleRoomControlSettings = 'singleRoomControlSettings',
  None = 'none',
}

export enum DiagnosticsUrlTypeEnum {
  Backups = 'backups',
  ExtendedParameter = 'extended-parameter',
  GuidedTroubleshooting = 'guided-troubleshooting',
  HydraulicSchematic = 'hydraulic-schematic',
  Snapshots = 'snapshots',
}

export enum SingleRoomControlUrlTypeEnum {
  Commissioning = 'commissioning',
}

export enum RemoteServiceUrlTypeEnum {
  Anomalies = 'remote-service-anomalies',
  Diagnosis = 'remote-service-diagnosis',
  Features = 'remote-service-features',
  Report = 'remote-service-report',
}

export enum PartnerAccessOverlayTypeEnum {
  Settings = 'partnerAccessSettings',
  None = 'none',
}

export enum ServiceInstructionTabsEnum {
  ServiceDocument = 'SERVICE_DOCUMENT',
  FurtherDocument = 'FURTHER_DOCUMENT',
}
